import type { PropertiesTableProps } from '../../shared/types'
import { TypographyProperties } from './TypographyDocs'

export const ParagraphProperties: PropertiesTableProps = {
  ...TypographyProperties,
}
